import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { ReviewIcon } from './ReviewIcon';
import styles from './index.module.scss';
interface ReviewTextProps {
  text?: string;
  isAutomaticReview?: boolean;
  isPreview?: boolean;
}
const EMPTY_REVIEW_TEXT = 'Questa recensione non contiene testo.';
const AUTOMATIC_REVIEW_TEXT = 'Recensione automatica generata da Subito. Affare concluso con successo.';
const EmptyReviewText = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className={styles["review-box"]}><p className="body-text small">{EMPTY_REVIEW_TEXT}</p></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const AutomaticReviewText = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <article className={styles["review-box"]}><p className="body-text small">{AUTOMATIC_REVIEW_TEXT}</p></article>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const ReviewText = t0 => {
  const $ = _c(8);
  const {
    text,
    isAutomaticReview,
    isPreview
  } = t0;
  if (isAutomaticReview) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <AutomaticReviewText />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (!text) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyReviewText />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ReviewIcon />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isPreview) {
    t2 = classNames("body-text", styles.text, {
      [styles.preview]: isPreview
    });
    $[3] = isPreview;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== text) {
    t3 = <article className={styles["review-box"]}>{t1}<p className={t2}>{text}</p></article>;
    $[5] = t2;
    $[6] = text;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};